import type { PageCard } from '@/play/pageTypes'
import { SandLettersCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'sand-letters',
  number: 22,
  title: 'Sand letters',
  question: 'Does uncovering a hidden letter by writing in sand with a finger feel good?',
  status: 'open',
  accent: '#ead6a6',
  CardArt: SandLettersCardArt,
}
